module.exports = __webpack_public_path__ + "static/media/PR_55_04.008e282a.jpg";